import { selectOpenModuleSet } from '../ReduxStorage/Courses/ModuleDisplay/selectors';
import { closeModuleDisplay } from '../ReduxStorage/Courses/ModuleDisplay/dispatchers';

export const keyPressed = (event) => (dispatch, getState) => {
  if (event.keyCode === 27) {
    // Escape
    const state = getState();
    if (selectOpenModuleSet(state)) {
      // Close the module set drawer
      dispatch(closeModuleDisplay());
    }
  }
};
